import { React, useEffect, useState } from 'react';
import { PAGE_ROUTE, API_URL } from '../../shared/constant';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../shared/table';
import LoaderComponent from '../../shared/loader';
import { AiOutlineSearch } from 'react-icons/ai';
import { Form } from 'react-bootstrap';
import moment from 'moment/moment';
import axios from 'axios';

const PostsDailyReportComponent = () => {
    const [search, setSearch] = useState('');
    const [viewType, setViewType] = useState('');

    const columns = [
        {
            field: 'id',
            lable: 'ID'
        }, {
            field: 'post_id',
            lable: 'Post ID'
        }, {
            field: 'quote_id',
            lable: 'Quote ID'
        }, {
            field: 'p_ip',
            lable: 'IP'
        }, {
            field: 'referer',
            lable: 'Referer'
        },
        {
            field: 'views',
            lable: 'Views'
        },
        {
            field: 'updated_at',
            lable: 'Last Update'
        }
    ];
    const [total, setTotal] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    useEffect(() => {
        getDailyReport("");
    }, []);

    useEffect(() => {
        isRecall && getDailyReport(viewType);
    }, [isRecall]);

    const getDailyReport = (viewTypeFilter) => {
        setLoading(true);
        const filters = {};
        
        if (viewTypeFilter) {
            filters.view_type = viewTypeFilter;
        }
        console.log('filters', filters);

        axios.post(API_URL.ADMIN_POSTS_DAILY_REPORT, filters).then(res => {
            if (res.data.status === 1) {
                const reportData = res.data.data || [];
                setData(reportData);
                setTotal(reportData.length || 0);
                
                reportData.map((element) => {
                    element.date = moment(element.date).format('ll');
                    element.updated_at = moment(element.updated_at).format('lll');
                    return element;
                });
            }
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        });
    };

    const updateViewType = (val) => {
        setViewType(val);
        getDailyReport(val);
    };

    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Daily Report ({total})

                        <nav aria-label="Page navigation example">
                            <div className="input-group mt-3">

                                <div className='input-form'>
                                    <Form.Select 
                                        aria-label="View Type"
                                        value={viewType}
                                        onChange={(event) => { updateViewType(event.target.value) }}
                                    >
                                        <option value="">All Types</option>
                                        <option value="post">Post</option>
                                        <option value="quote">Quote</option>
                                    </Form.Select>
                                </div>

                            </div>
                        </nav>
                    </h4>

                    {
                        isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    isShowAction={false}
                                    columns={columns}
                                    data={data}>
                                </TableComponent>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PostsDailyReportComponent;
